var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-select",
        {
          directives: [
            {
              name: "selectLoadMore",
              rawName: "v-selectLoadMore",
              value: _vm.selectLoadMore,
              expression: "selectLoadMore",
            },
          ],
          staticClass: "width100",
          attrs: {
            size: "small",
            clearable: "",
            filterable: "",
            loading: _vm.loading,
            remote: "",
            multiple: _vm.multiple,
            "remote-method": _vm.remoteMethod,
            placeholder: "请选择快递公司",
          },
          on: { change: _vm.handleChange },
          model: {
            value: _vm.logisticsCode,
            callback: function ($$v) {
              _vm.logisticsCode = $$v
            },
            expression: "logisticsCode",
          },
        },
        _vm._l(_vm.logisticsList, function (user) {
          return _c("el-option", {
            key: user.code,
            attrs: { label: user.name, value: user.code },
          })
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }